import { eventBus } from '@/main.js'
import api from '@/services/grayhound/api.service.js'
import { Observable } from 'rxjs'
import authAPI from '@/services/auth/auth.api.service.js'

export default {
  methods: {
    getWinningJackpot () {
      return Observable.create((observer) => {
        api.getBalance()
        api.getWinningJackpot().subscribe(data => {
          // data.Tickets = []
          // data.Tickets.push({ 'JackpotName': 'Local JP Location', 'JackpotAmount': 400.2, 'Barcode': '5245923655691', 'LocationName': 'Test Migracija 1' })
          // data.Tickets.push({ 'JackpotName': 'Local JP Location', 'JackpotAmount': 500.2, 'Barcode': '2222222222221', 'LocationName': 'Test Migracija 2' })
          // data.Tickets.push({ 'JackpotName': 'Local JP Location', 'JackpotAmount': 1000.2, 'Barcode': '5245923655691', 'LocationName': 'Test Migracija 3' })
          // data.Tickets.push({ 'JackpotName': 'Super JP Location', 'JackpotAmount': 1000.2, 'Barcode': '5245923655691', 'LocationName': 'Test Migracija 4' })
          // data.Tickets.push({ 'JackpotName': 'Super JP Location', 'JackpotAmount': 700.2, 'Barcode': '4444444444444', 'LocationName': 'Test Migracija 5' })
          // data.Tickets.push({ 'JackpotName': 'Super JP Location', 'JackpotAmount': 600.2, 'Barcode': '5555555555555', 'LocationName': 'Test Migracija 6' })
          if (data.Tickets.length > 0) {
            observer.next(this.getVideoJackpotByType(data))
          } else {
            observer.next({ 'isJackpotActive': false })
          }
          observer.complete()
        }, eventBus.onApiErrorVDog)
      })
    },
    getVideoJackpotByType (jackpotData) {
      let isLocalJackpot = jackpotData.Tickets.filter(
        jackpot => jackpot.JackpotName.includes('Local JP')
      )
      let isSuperJackpot = jackpotData.Tickets.filter(
        jackpot => jackpot.JackpotName.includes('Super JP')
      )
      let videoJackpotType = 0
      let video = authAPI.getUrlForVDogLocalJackpot()
      if (isLocalJackpot.length > 0 && !isSuperJackpot.length > 0) {
        videoJackpotType = 1
      } else if (!isLocalJackpot.length > 0 && isSuperJackpot.length > 0) {
        videoJackpotType = 2
        video = authAPI.getUrlForVDogSuperJackpot()
      }
      return {
        'isJackpotActive': true,
        'videoLink': video,
        'videoJackpotType': videoJackpotType,
        'localJackpot': isLocalJackpot,
        'superJackpot': isSuperJackpot,
        'metadata': this.prepareMetaDataForJackpotVideo(videoJackpotType, isLocalJackpot, isSuperJackpot)
      }
    },
    prepareMetaDataForJackpotVideo (videoJackpotType, localJP, superJP) {
      let metaDataArray = []
      let jackpotData = []
      let waitingTime = 2
      let timeInterval = 0
      if (videoJackpotType === 1) {
        jackpotData = localJP
      } else if (videoJackpotType === 2) {
        jackpotData = superJP
      } else {
        jackpotData = localJP.concat(superJP)
        waitingTime = 3
      }
      timeInterval = (20 - waitingTime) / jackpotData.length
      for (let i = 0; i < jackpotData.length; i++) {
        metaDataArray.push({
          Time: waitingTime + timeInterval * i,
          Ticket: jackpotData[i],
          Type: videoJackpotType
        })
      }
      return metaDataArray
    }
  }
}
